export const getChatsOpened = (state) => state.chat.chatsOpened;
